export enum ColumnFilterEnum {
  DateRange = 'DateRange',
  Switcher = 'Switcher',
  Options = 'Options',
}
